import Reveal from "../components/Reveal";
import usePageMeta from "../hooks/usePageMeta";

const DOCS = {
    privacidade: {
        titulo: "Política de Privacidade",
        seoTitle: "Política de Privacidade | Smart Benefícios",
        blocos: [
            {
                h: "1. Sobre esta política",
                p: ["Esta Política de Privacidade descreve como a Smart Benefícios trata as informações coletadas através deste site institucional, em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018)."],
            },
            {
                h: "2. Dados coletados",
                p: [
                    "Coletamos exclusivamente os dados que você informa voluntariamente no formulário de contato: nome, empresa, CNPJ, e-mail, telefone, WhatsApp, número de colaboradores e mensagem.",
                    "Esses dados são utilizados única e exclusivamente para que a equipe da Smart Benefícios entre em contato com você e apresente suas soluções.",
                ],
            },
            {
                h: "3. Uso das informações",
                p: ["As informações enviadas não são compartilhadas com terceiros para fins comerciais e são armazenadas de forma segura, permanecendo pelo tempo necessário para atender à sua solicitação."],
            },
            {
                h: "4. Seus direitos",
                p: ["Você pode solicitar a qualquer momento o acesso, a correção ou a exclusão dos seus dados pessoais, por meio dos canais de contato disponíveis na página de contato do site."],
            },
            {
                h: "5. Atualização",
                p: ["Esta política pode ser atualizada periodicamente. Recomendamos que você consulte esta página regularmente."],
            },
        ],
    },
    termos: {
        titulo: "Termos de Uso",
        seoTitle: "Termos de Uso | Smart Benefícios",
        blocos: [
            {
                h: "1. Objeto",
                p: ["Estes Termos de Uso regulamentam a navegação e o uso do site institucional da Smart Benefícios. O site tem caráter informativo e comercial, apresentando a empresa, suas soluções e seu modelo de mensalidade fixa."],
            },
            {
                h: "2. Conteúdo",
                p: [
                    "Todo o conteúdo deste site — textos, marcas, identidade visual e materiais — pertence à Smart Benefícios e não pode ser reproduzido sem autorização prévia.",
                    "Os valores e condições comerciais apresentados, incluindo planos a partir de R$ 99/mês, poderão ser confirmados no momento da contratação.",
                ],
            },
            {
                h: "3. Responsabilidade",
                p: ["A Smart Benefícios envida seus melhores esforços para manter as informações deste site precisas e atualizadas, não se responsabilizando por eventuais incorreções temporárias."],
            },
            {
                h: "4. Contato",
                p: ["Dúvidas sobre estes termos podem ser enviadas pelos canais disponíveis na página de contato do site."],
            },
        ],
    },
};

export default function Legal({ doc }) {
    const conteudo = DOCS[doc];
    usePageMeta(conteudo.seoTitle, `${conteudo.titulo} do site institucional da Smart Benefícios.`);

    return (
        <section className="bg-white pb-24 pt-[128px] md:pt-[168px]" data-testid={`pagina-legal-${doc}`}>
            <div className="container-x max-w-3xl">
                <Reveal>
                    <h1 className="font-display text-4xl font-extrabold tracking-tight text-tinta sm:text-5xl" data-testid="legal-title">
                        {conteudo.titulo}
                    </h1>
                    <p className="mt-3 text-sm text-tinta-suave">Smart Benefícios · CNPJ 29.767.611/0001-41</p>
                </Reveal>
                <div className="mt-10 space-y-8">
                    {conteudo.blocos.map((b, i) => (
                        <Reveal key={b.h} delay={i * 0.05}>
                            <div>
                                <h2 className="font-display text-xl font-bold text-azul-900" data-testid="legal-subtitulo">{b.h}</h2>
                                {b.p.map((par, j) => (
                                    <p key={j} className="mt-3 text-[15px] leading-relaxed text-tinta-medio">{par}</p>
                                ))}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
